import { createApiInstance, setDefaultInstance } from '@inscore/shared';

const api = createApiInstance({
    baseURL: 'https://api.naijascore.com',
});

// Set this as the default instance for all API classes
setDefaultInstance(api);

export default api;
